import { AnswerType } from "../constants"

export function checkIsInput(type: AnswerType) {
    return type === AnswerType.number || type === AnswerType.short_text
}
